import { render } from "./OdMonoPill.vue?vue&type=template&id=088ace28"
import script from "./OdMonoPill.vue?vue&type=script&lang=js"
export * from "./OdMonoPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__